import React from 'react';
import { Modal } from 'antd';
import { func, bool } from 'prop-types';
import { Text, FlexContainer, IconContainer, Icon, Row, Button } from '../../common';


const ModalRepeatUser = ({ visible, onClose}) => {
    return <Modal
        footer={<Row justify='flex-end'>
            <Button
                text='Cerrar'
                width={85}
                secondary
                onClick={onClose}
            />
        </Row>}
        title='Creación de usuario'
        visible={visible}
        onCancel={onClose}
    >
        <FlexContainer style={{ marginBottom: 20 }} direction='column' align='center'>
            <IconContainer color='#ffffff' size={70}>
                <Icon name='caution' color='#D60000' size={46.8} />
            </IconContainer>
            <Text text={'No se pudo crear/activar usuario debido a que el rut ya esta registrado, se deberá desactivar estos usuarios si se desea proceder con la acción.'} />
        </FlexContainer>
    </Modal>;
};

ModalRepeatUser.propTypes = {
    onClose: func,
    visible: bool,
};


export default ModalRepeatUser;
